export const defaultQuestions = {
  society: [
    '¿Cuál es la valoración actual de nuestra empresa y cómo ha cambiado a lo largo de los años?',
    'Muéstrame un resumen del rendimiento financiero anual (facturación, EBITDA) y sus tendencias',
    '¿Cuántos socios activos, beneficiarios e inversores tenemos actualmente?',
    '¿Qué integraciones están habilitadas y validadas para nuestra empresa?',
    'Dame un resumen de la composición del consejo y el estado de los directores',
  ],
  partners: [
    '¿Quiénes son nuestros 5 principales socios por porcentaje de participación?',
    '¿Cuántos socios nuevos hemos añadido en los últimos 6 meses?',
    '¿Qué socios tienen acuerdos de representación y cuándo expiran?',
    'Muéstrame los socios agrupados por categoría y tipo de participación',
    'Lista todos los socios inactivos y sus fechas de última actividad',
  ],
  beneficiaries: [
    '¿Cuántos beneficiarios están en estado borrador vs. estado activo?',
    '¿Cuál es el total de acciones asignadas a nuestros planes de opciones?',
    '¿Qué beneficiarios tienen invitaciones pendientes sin aceptar?',
    'Muéstrame el resumen de cronogramas de consolidación para todos los beneficiarios activos',
    'Lista los beneficiarios cuyas opciones se acercan a las fechas de cliff',
  ],
  investors: [
    '¿Cuál es la financiación total recaudada y de cuántos inversores?',
    '¿Quiénes son nuestros inversores más grandes por cantidad de contribución?',
    'Muéstrame el desglose de rondas de inversión por fecha e importes',
    '¿Qué inversores tienen porcentajes de descuento aplicados a sus contribuciones?',
    '¿Cuál es la cantidad promedio de inversión por inversor en nuestra última ronda?',
  ],
  operations: [
    '¿Cuáles fueron nuestras operaciones de capital más recientes y su impacto?',
    'Muéstrame todas las distribuciones de dividendos del último ejercicio fiscal',
    '¿Qué operaciones involucraron cambios o conversiones de clases de acciones?',
    '¿Cuál es el volumen total de acciones movidas en nuestras últimas 5 operaciones?',
    'Lista todas las operaciones que están pendientes de registro notarial',
  ],
  boards: [
    '¿Cuántas juntas tenemos programadas para este mes y cuáles están activas?',
    'Muéstrame el resumen de asistencia de los últimos 6 meses en las juntas',
    '¿Qué juntas tienen votación digital habilitada y cuál es su estado?',
    'Lista todas las juntas pendientes de documentación o actas',
    '¿Cuáles son los órdenes del día más frecuentes en nuestras juntas?',
  ],
  communications: [
    '¿Cuántas comunicaciones hemos enviado este mes y cuál es su tasa de apertura?',
    'Muéstrame las comunicaciones con mayor tasa de rechazo y sus motivos',
    '¿Qué comunicaciones están en estado borrador o programadas?',
    'Lista los destinatarios con direcciones de email inválidas',
    '¿Cuáles son nuestras comunicaciones favoritas y archivadas?',
  ],
  documents: [
    '¿Cuántos documentos hemos generado este año por categoría?',
    'Muéstrame los documentos más accedidos recientemente',
    '¿Qué documentos están marcados como favoritos por los administradores?',
    'Lista todos los documentos vinculados a operaciones específicas',
    '¿Cuáles son los documentos comunes más utilizados?',
  ],
  employees: [
    '¿Cuántos empleados tenemos actualmente y cuál es su distribución por equipos?',
    'Muéstrame el resumen de contratos activos y sus fechas de finalización',
    '¿Qué empleados han tenido cambios salariales en los últimos 6 meses?',
    'Lista los empleados con fechas de terminación próximas',
    '¿Cuál es el rango salarial promedio por puesto de trabajo?',
  ],
  stockPlans: [
    '¿Cuántos planes de opciones tenemos activos y cuál es su pool total?',
    'Muéstrame el resumen de planes con consolidación personalizada',
    '¿Qué planes tienen invitaciones pendientes de envío?',
    'Lista los planes que han sido liquidados y sus unidades restantes',
    '¿Cuáles son los precios de ejercicio de nuestros diferentes planes?',
  ],
  tenderOffers: [
    '¿Cuántas ofertas de compra tenemos activas y cuál es su valor total?',
    'Muéstrame las ofertas que expiran en los próximos 30 días',
    '¿Qué ofertas tienen restricciones de porcentaje máximo?',
    'Lista todas las ofertas dirigidas a planes específicos',
    '¿Cuál es el precio promedio por acción en nuestras ofertas activas?',
  ],
  shares: [
    '¿Cuál es la distribución actual de acciones por clase de participación?',
    'Muéstrame las acciones con gravámenes o cargas registradas',
    '¿Qué acciones tienen fechas de vesting próximas?',
    'Lista las acciones inactivas y sus motivos',
    '¿Cuáles son los rangos de numeración de acciones más grandes?',
  ],
};
